import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { API } from "aws-amplify";
import moment from "moment";
import { formatNumber, getPdfSimulacion, handleState } from "../../Utils/utils";
import { generatePdfSimulateAS } from "../../Services/GeneratePdfSimulateAS";

import {
  addClient,
  addHealthStatement,
  addWorkData,
  modalAside,
  addBeneficiary,
  stateAlert,
  alert,
} from "../../Store/simulate/actions";
import { decryptEstandar } from "../../Utils/CryptographyUtils";
import Table from "./Table";
import Button from "./Button";
import IconDowload from "../../Resources/svg/Icons/IconDowload";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import Loading from "../loading";
import Flags from "./Flags";
import Tooltips from "./Tooltips";
import IconReport from "../../Resources/svg/Icons/IconReport";
import IconSend from "../../Resources/svg/Icons/IconSend";
import ModalAlertSendEmail from "../modalAlertSendEmail";
import CardTabla from "./CardTabla";
import CardTablaRG from "./CardTablaRG";
import { invesment, typeCurrency, typeCurrencyValues } from "../../Utils/constants";
import { getBenefitLabel } from "../../Pages/wizard/FormElements/RVEO";

const TableSimulation = ({
  data,
  codProd,
  activeProduct,
  setModalData,
  activeProductCode,
  getQuotes,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const asesor = useSelector((state) => decryptEstandar(state.login.username));

  const [linkPdf, setLinkPdf] = useState("");

  const [openModalAlertSendEmail, setOpenModalAlertSendEmail] = useState(false);

  const elem = useRef(null);

  const channel = useSelector((state) => state.login.channel);

  const onClickCotizar = (item) => {
    let rutas = {
      IG: "/cotizaciones/datos-personales",
      AS: "/cotizaciones/datos-personales",
      UC: "/cotizaciones/datos-personales",
      RG: "/cotizaciones/datos-personales",
    };

    dispatch(addClient(item));
    dispatch(addWorkData({}));
    dispatch(addHealthStatement([]));
    dispatch(addBeneficiary([]));
    // //manejo de simulacion y pasos
    history.push(rutas[item.producto.codigo]);

    window.digitalData.push({
      action: {
        group: "Simulaciones",
        category: "Listado",
        name: getTitleCase(activeProduct),
        label: "Cotizar",
      },
      event: "trackAction",
    });
  };

  const codigo = codProd;

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("DD/MM/YYYY");
  };

  const getSimulationPdfUrl = (simulation) => {
    return typeof simulation.urlPDF === "string"
      ? simulation.urlPDF.trim()
      : "";
  };

  const generatePdfSimulate = async (data) => {
    setIsLoading(true);
    if (["IG", "UC"].includes(data.producto.codigo)) {
      const response = await API.get(
        "api-rentas",
        "/generate-pdf/" + data.idSimulacion
      );

      if (response.status) {
        setLinkPdf(response.data);
      } else {
        //alert(response.message)
      }

      setIsLoading(false);
    } else if (["AS"].includes(data.producto.codigo)) {
      setIsLoading(false);
      return generatePdfSimulateAS(data);
    } else if (data.producto.codigo == "RG") {
      const rowData = [{ idQuote: data.idSimulacion }];
      const response = await getPdfSimulacion("RG", rowData);
      if (response.status) {
        setLinkPdf(response.data);
      } else {
        console.log(response.message);
      }
      setIsLoading(false);
    }

    window.digitalData.push({
      action: {
        group: "Simulaciones",
        category: "Listado",
        name: getTitleCase(activeProduct),
        label: "Descargar",
      },
      event: "trackAction",
    });
  };

  const availableBottons = (item) => {
    return (
      item.estado !== "Vencida" &&
      ["AS", "IG", "UC", "RG"].includes(item.producto.codigo)
    );
  };

  const handleReviewSimulation = (item) => {
    setModalData(item);
    dispatch(modalAside(true));
  };

  const disabledButtons = (item) => {
    const actions = {
      quote: false,
      improve: false,
      pdf: false,
      send: false,
    };

    switch (item.estado) {
      case "pendiente":
        actions.quote = true;
        actions.improve = true;
        break;
      case "revision":
        actions.quote = true;
        actions.improve = true;
        actions.send = true;
        break;
      case "aprobada":
      case "vigente":
        actions.send = true;
        break;
      case "rechazada":
        actions.quote = true;
        actions.improve = true;
        actions.send = true;
        break;
      case "vencida":
        if (!channel.includes("admin")) { //!VALIDAR
          actions.quote = true;
          actions.improve = true;
          actions.send = true;
          actions.pdf = true;
        }
      default:
        break;
    }

    return actions;
  };

  const handleSendEmail = async ({ idSimulacion }) => {
    setIsLoading(true);
    try {
      const response = await API.post("api-rentas", "/plaft/send-simulation", {
        body: { idSimulacion },
      });
      setIsLoading(false);
      const { statusCode } = response;
      if (statusCode !== 200)
        return setAlert("error", "Error", "La simulación no es válida");
      setOpenModalAlertSendEmail(true);
    } catch (error) {
      console.log(error);
      setAlert("error", "Error", "Ocurrió un error al enviar el correo");
      setIsLoading(false);
    }
  };

  const setAlert = (type, title, message) => {
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type,
        title,
        message,
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 2500);
  };

  useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  return (
    <>
      <div className="table-box">
        <a
          style={{ display: "none" }}
          target="_blank"
          rel="noopener noreferrer"
          href={linkPdf}
          ref={elem}
        />
        <Table>
          <thead>
            <tr>
              {codigo === "RVEO" ? (
                <>
                  <th width="128">Nº DE SOLICITUD</th>
                  <th width="122">CUSPP</th>
                  <th width="122">DNI / CE</th>
                  <th width="180">ASEGURADO</th>
                  <th width="96">FECHA</th>
                  <th>CAPITAL</th>
                  <th width="110">MONEDA</th>
                  <th width="110">PRESTACIÓN</th>
                  <th width="110">REM. PROM.</th>
                  <th>ACCIONES</th>
                </>
              ) : (
                <>
                  <th width="128">Nº DE simulación</th>
                  <th width="96">Fecha</th>
                  <th width="122">contratante</th>
                  <th>DNI / CE</th>
                  <th width="110">PRIMA COMERCIAL</th>
                  {codigo == "IG" ? (
                    <>
                      <th width="110">PRIMA BASE</th>
                      <th width="110">PRIMA AHORRO</th>
                    </>
                  ) : codigo === "UC" ? (
                    <>
                      <th width="110">Suma Asegurada</th>
                    </>
                  ) : (
                    <th width="110">TASA</th>
                  )}
                  <th>VENCIMIENTO</th>
                  <th width="180">ESTADO</th>
                  <th>ACCIONES</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((item, index) => {
                const isRVEO =
                  ["RVEO", "RV"].includes(item.codProducto) ||
                  (["RVEO", "RV"].includes(codigo) && !item.datosCliente);
                const pdfUrl = getSimulationPdfUrl(item);

                return (
                  <tr key={index}>
                    {isRVEO ? (
                      <>
                        <td>{item.nroSolicitud || "-"}</td>
                        <td>{item.cuspp || "-"}</td>
                        <td>{item.numeroDocumentoAsegurado || "-"}</td>
                        <td>{`${item.nombreAsegurado || ''} ${item.apellidosAsegurado || ''}` || "-"}</td>
                        <td>
                          {item.fechaCalculo
                            ? formatDate(item.fechaCalculo)
                            : formatDate(item.createdAt)}
                        </td>
                        <td>
                          {item.moneda && 
                            (item.moneda.toLowerCase().includes("dólares") ||
                            item.moneda === typeCurrencyValues["dolares-ajustados"] ||
                            item.moneda === typeCurrencyValues["dolares-nominales"])
                            ? "$ "
                            : "S/ "}
                          {formatNumber.new(item.capital || 0)}
                        </td>
                        <td>
                          {typeCurrency[item.monedaModalidad] || item.monedaModalidad || "-"}
                        </td>
                        <td>
                          {getBenefitLabel(item.prestacion) || "-"}
                        </td>
                        <td>{formatNumber.new(item.remProm || 0)}</td>
                        <td>
                          <div className="action-container">
                            <Button
                              type="button"
                              className="btn is-small is-secondary"
                              onClick={() => {
                                setModalData(item);
                                dispatch(modalAside(true));
                              }}
                            >
                              Ver
                            </Button>
                            {pdfUrl && (
                              <div
                                className="action-container__item"
                                onClick={() => window.open(pdfUrl, "_blank")}
                              >
                                <IconDowload />
                                <span>Descargar</span>
                              </div>
                            )}
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td>
                          {item.numSimulacion ||
                            item.datosCliente.documentoCliente}
                        </td>
                        <td>{item.fechaCreacion}</td>
                        {item.contratante && (
                          <>
                            <td>
                              {Object.keys(item.contratante).length === 0
                                ? getTitleCase(item.datosCliente.nombres)
                                : item.contratante.typeContractor == "PERSON"
                                  ? getTitleCase(
                                      item.contratante.names +
                                        " " +
                                        item.contratante.firstName +
                                        " " +
                                        item.contratante.lastName
                                    )
                                  : item.contratante.companyName}
                            </td>
                            <td>
                              {Object.keys(item.contratante).length === 0
                                ? item.datosCliente.documento
                                : item.contratante.nroDoc}
                            </td>
                          </>
                        )}
                        <td>
                          {item.datosSimulacion.moneda && (
                            <>
                              {item.datosSimulacion.moneda
                                ? item.datosSimulacion.moneda.simbolo
                                : ""}
                              &nbsp;
                            </>
                          )}
                          {formatNumber.new(item.datosSimulacion.prima)}
                        </td>
                        {item.producto.codigo == "IG" ? (
                          <>
                            <td>
                              {item.datosSimulacion.moneda && (
                                <>
                                  {item.datosSimulacion.moneda
                                    ? item.datosSimulacion.moneda.simbolo
                                    : ""}
                                  &nbsp;
                                </>
                              )}
                              {formatNumber.new(
                                item.datosSimulacion.primaBase || ""
                              )}
                            </td>
                            <td>
                              {item.datosSimulacion.moneda && (
                                <>
                                  {item.datosSimulacion.moneda
                                    ? item.datosSimulacion.moneda.simbolo
                                    : ""}
                                  &nbsp;
                                </>
                              )}
                              {formatNumber.new(
                                item.datosSimulacion.primaAhorro || ""
                              )}
                            </td>
                          </>
                        ) : (
                          <td>
                            {item.producto.codigo == "UC"
                              ? item.datosSimulacion.sumaAsegurada !== null && (
                                  <>
                                    {item.datosSimulacion.moneda && (
                                      <>
                                        {item.datosSimulacion.moneda
                                          ? item.datosSimulacion.moneda.simbolo
                                          : ""}
                                        &nbsp;
                                      </>
                                    )}
                                    {formatNumber.new(
                                      item.datosSimulacion.sumaAsegurada || ""
                                    )}
                                  </>
                                )
                              : item.datosSimulacion.tasa !== null && (
                                  <>{item.datosSimulacion.tasa}%</>
                                )}
                          </td>
                        )}
                        <td>{item.datosSimulacion.vencimiento}</td>
                        <td>
                          <div className="flag-state-info">
                            <Flags variant={item.estado}>
                              {handleState(item.estado)}
                            </Flags>
                            {item.descripcionEstado && (
                              <Tooltips text={item.descripcionEstado} />
                            )}
                          </div>
                        </td>
                        <td>
                          <div className="action-container">
                            {true ? (
                              <>
                                <Button
                                  type="button"
                                  className="btn is-small is-secondary"
                                  onClick={() =>
                                    !disabledButtons(item).quote
                                      ? onClickCotizar(item)
                                      : false
                                  }
                                  disabled={disabledButtons(item).quote}
                                >
                                  Cotizar
                                </Button>

                                {channel.includes("admin") &&
                                  item.producto.codigo ==
                                    invesment.RENTA_GARANTIZADA && (
                                    <>
                                      <div
                                        onClick={() =>
                                          !disabledButtons(item).improve
                                            ? handleReviewSimulation(item)
                                            : false
                                        }
                                        className={`action-container__item ${disabledButtons(item).improve ? " disabled-action" : ""}`}
                                      >
                                        <IconReport />
                                        <span>Mejorar</span>
                                      </div>
                                    </>
                                  )}

                                <div
                                  className={`action-container__item ${disabledButtons(item).pdf ? " disabled-action" : ""}`}
                                >
                                  <IconDowload
                                    onClick={() =>
                                      !disabledButtons(item).pdf
                                        ? generatePdfSimulate({
                                            ...item,
                                            asesor,
                                          })
                                        : false
                                    }
                                  />
                                </div>

                                <div
                                  className={`action-container__item ${disabledButtons(item).send ? " disabled-action" : ""}`}
                                >
                                  <IconSend
                                    onClick={() =>
                                      !disabledButtons(item).send
                                        ? handleSendEmail(item)
                                        : false
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              <>-</>
                            )}
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </Table>
        {isLoading && <Loading />}
      </div>
      {codProd !== "RVEO" &&
        (codProd === "RG" ? (
          <>
            {data
              .filter((item) => item.codProducto !== "RVEO")
              .map((datos, index) => (
                <CardTablaRG
                  data={datos}
                  codProd={activeProductCode}
                  key={index}
                  activeProduct={activeProduct}
                  availableButtons={availableBottons}
                  showActions={disabledButtons}
                  setOpenModalAlertSendEmail={setOpenModalAlertSendEmail}
                  handleReviewSimulation={handleReviewSimulation}
                />
              ))}
          </>
        ) : (
          <>
            {data
              .filter((item) => item.codProducto !== "RVEO")
              .map((datos, index) => (
                <CardTabla
                  data={datos}
                  codProd={activeProductCode}
                  key={index}
                  activeProduct={activeProduct}
                />
              ))}
          </>
        ))}

      <ModalAlertSendEmail
        openModal={openModalAlertSendEmail}
        setOpenModal={setOpenModalAlertSendEmail}
        handleClose={getQuotes}
      />
    </>
  );
};

export default TableSimulation;
